import React from 'react'

import logoProyecto from './../../UI/Loading/logo_desarrollo.svg'
import close from './../../UI/quotation/Close.svg'
import cotiza from './../../UI/TopMenu/Icon_cotiza.svg'
//import testdrive from './../../UI/mobile/sidebar/test_drive.svg'
import sound from './../../UI/TopMenu/Icon_SoundON.svg'
import  soundOff from './../../UI/TopMenu/Icon_SoundOFF.svg'
import arrowBtn from './../../UI/general/arrow_btn.svg'
import { cotizaData } from '../../data/cotiza.data';

interface Props {
  openSidebar: boolean,
  currentCarSelected: string,
  handleOpenSidebar: () => void,
  handleMuteSong: () => void
  isMuted: boolean
  handleQuotation: (payload: boolean) => void
  isQuotationOpened: boolean
  currentCompleteCar: any
  enableInternalCotizaGlobally: boolean,
}

interface State {
  modelLink: any
}

class Sidebar extends React.Component<Props,State>{
  constructor(props: Props){
    super(props); 
    this.state = {
      modelLink: ''
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    if(this.props.currentCompleteCar !== prevProps.currentCompleteCar){
      var cotizaLinks: any = cotizaData()
      this.setState({
        modelLink: cotizaLinks[this.props.currentCompleteCar]
      })
    }
  }

  render(): React.ReactNode {
      return(
        <div className={this.props.openSidebar ? 'sidebar-container-mobile fade-in':'sidebar-container-mobile fade-out'}>
          <div className='sidebar-mobile'>
            <div className='sidebar-logo-close-container'>
              <div className='logo-container'>
                <img src={logoProyecto} alt=''/>
              </div>
              <div className='close-btn' onClick={() => {this.props.handleOpenSidebar()}}>
                <img src={close} alt=''/>
              </div>
            </div>

            <hr/>

            <div className='sidebar-current-car-selected'>
              {this.props.currentCarSelected}
            </div>

            <div className='sidebar-options-container'>
              { this.props.enableInternalCotizaGlobally === true ?
                <div className='sidebar-option-individual-container' onClick={() =>  {this.props.handleQuotation(true); this.props.handleOpenSidebar()}} >
                  <img src={cotiza} alt=''/>
                  <div className='sidebar-option-name'>Cotiza este vehículo</div>
                </div>
                :
                <a href={this.state.modelLink} target='_blank' rel='noreferrer' style={{textDecoration: 'none'}}>
                  <div className='sidebar-option-individual-container'>
                    <img src={cotiza} alt=''/>
                    <div className='sidebar-option-name'>Cotiza este vehículo</div>
                  </div>
                </a>
              }

              {/*
                <div className='sidebar-option-individual-container'>
                  <img src={testdrive} alt=''/>
                  <div className='sidebar-option-name'>Test drive</div>
                </div>
              */}
              <div className='sidebar-option-individual-container' onClick={() => {
                this.props.handleMuteSong()
                }}>
                <img src={ !this.props.isMuted ? sound:soundOff} alt=''/>
                <div className='sidebar-option-name'>{ !this.props.isMuted ? 'Desactivar sonido':'Activar sonido'}</div>
              </div>
            </div>

            <hr/>

            <div className='sidebar-back-btn' onClick={() => {this.props.handleOpenSidebar()}}>
              <img src={arrowBtn} alt=''/>
              <div className='sidebar-back-btn-text'>SALIR</div>
            </div>
          </div>
        </div>
      )
  }
}

export default Sidebar